// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1d-gl","options":"AnswerScale_options__12byT","selected":"AnswerScale_selected__1_8xx"};